import { render, staticRenderFns } from "./LifecycleManagement.vue?vue&type=template&id=dafd9ec2&scoped=true&"
import script from "./LifecycleManagement.vue?vue&type=script&lang=js&"
export * from "./LifecycleManagement.vue?vue&type=script&lang=js&"
import style0 from "./LifecycleManagement.vue?vue&type=style&index=0&id=dafd9ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafd9ec2",
  null
  
)

component.options.__file = "LifecycleManagement.vue"
export default component.exports